import { IconProps } from "../../types/icon";

export default function LogoutIcon({className = ""}: IconProps) {
  
  return (
    <svg className={className} width="19.601" height="17.966" viewBox="0 0 19.601 17.966">
      <defs>
        <clipPath id="clip-path">
          <rect width="19.601" height="17.966" fill="currentColor"/>
        </clipPath>
      </defs>
      <g clipPath="url(#clip-path)">
        <path d="M13.475,1.2a8.985,8.985,0,1,0,0,15.564.743.743,0,1,0-.744-1.287,7.5,7.5,0,1,1,0-12.991A.743.743,0,1,0,13.475,1.2" transform="translate(0 -0.001)" fill="currentColor"/>
        <path d="M251.969,160.167a.738.738,0,0,0,.525-.218L254.443,158c.182-.182.354-.354.486-.51a1.8,1.8,0,0,0,.36-.61,1.762,1.762,0,0,0,0-1.1,1.8,1.8,0,0,0-.36-.61c-.131-.154-.3-.325-.483-.506l-1.951-1.951a.743.743,0,0,0-1.051,1.051l1.822,1.822h-8.507a.743.743,0,1,0,0,1.486h8.507l-1.822,1.822a.743.743,0,0,0,.525,1.268" transform="translate(-235.776 -147.351)" fill="currentColor"/>
      </g>
    </svg>
  )
}